@if ((isImpersonating$ | async)) {
  <app-impersonate-bar></app-impersonate-bar>
}

<router-outlet></router-outlet>

<!-- Use a splash overlay to cover the content but not remove it from the DOM so we don't remove our component tree on navigation -->
@if(isLoading$ | async) {
  <div class="splash-overlay">
    <img [src]="loadingImagePath" alt="loading" />
  </div>
}
